import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { get } from 'lodash';
import WithShop from './WithShop';
import { formatReservationTime } from '../utils/helpers';

const mapStateToProps = (state, ownProps) => ({
  reservationTime: ownProps.params.reservationTime
    && formatReservationTime(ownProps.params.reservationTime, get(ownProps, 'shop.timezone')),
});

export default compose(
  withRouter,
  WithShop,
  connect(mapStateToProps),
);



// WEBPACK FOOTER //
// ./src/app/hoc/WithReservationTime.js